import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const SplitIcon = ({ className, color }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300.000000 300.000000"
    preserveAspectRatio="xMidYMid meet"
    className={getClassName(className)}
    fill={color}
    stroke="currentColor"
  >
    <g
      transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        d="M2357 2912 l-77 -77 130 -130 c72 -71 130 -133 130 -137 0 -3 -138
        -8 -307 -10 -340 -5 -364 -8 -500 -73 -154 -72 -188 -103 -468 -426 -245 -281
        -292 -327 -379 -371 -122 -61 -120 -61 -518 -65 l-368 -4 0 -114 0 -113 353
        -5 c380 -5 398 -7 513 -62 98 -47 144 -92 399 -385 274 -315 307 -345 452
        -418 136 -69 176 -75 516 -80 169 -2 307 -7 307 -10 0 -4 -58 -66 -130 -137
        l-130 -130 77 -77 c43 -43 82 -78 88 -78 6 0 133 123 283 273 l272 272 -273
        273 c-149 149 -277 272 -282 272 -6 0 -45 -35 -88 -78 l-77 -77 130 -130 c72
        -71 130 -133 130 -137 0 -15 -509 -9 -580 6 -85 18 -171 57 -236 106 -29 22
        -163 167 -298 322 -163 187 -270 301 -316 337 l-70 54 48 33 c76 53 116 95
        356 372 233 269 289 322 388 367 101 46 170 55 451 55 141 0 257 -3 257 -8 0
        -4 -58 -66 -130 -137 l-130 -130 77 -77 c43 -43 82 -78 88 -78 6 0 133 123
        283 273 l272 272 -273 273 c-149 149 -277 272 -282 272 -6 0 -45 -35 -88 -78z"
      />
    </g>
  </svg>
);

SplitIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

SplitIcon.defaultProps = {
  className: 'w-5 h-5',
  color: '#38495c',
};

export default SplitIcon;
